// Build identifier for the development environment only.
// Bump this manually on each dev deploy.
export const BUILD_NO = 'TEST';
